/**
 * Loading component with different sizes and styles
 */

import React from 'react';
import { clsx } from 'clsx';

const Loading = ({ 
  size = 'md', 
  text = null, 
  type = 'spinner',
  className = '',
  fullScreen = false 
}) => {
  const sizeClasses = {
    sm: 'w-4 h-4',
    md: 'w-6 h-6', 
    lg: 'w-8 h-8',
    xl: 'w-12 h-12',
  };

  const textSizeClasses = {
    sm: 'text-sm',
    md: 'text-base',
    lg: 'text-lg', 
    xl: 'text-xl',
  };

  const LoadingSpinner = () => (
    <div className={clsx(
      'loading-spinner',
      sizeClasses[size],
      className
    )} />
  );

  const LoadingDots = () => (
    <div className="loading-dots">
      <div />
      <div />
      <div />
    </div>
  );

  const LoadingPulse = () => (
    <div className={clsx(
      'bg-primary-600 rounded-full animate-pulse',
      sizeClasses[size],
      className
    )} />
  );

  const renderLoader = () => {
    switch (type) {
      case 'dots':
        return <LoadingDots />;
      case 'pulse':
        return <LoadingPulse />;
      default:
        return <LoadingSpinner />;
    }
  };

  const content = (
    <div className={clsx(
      'flex flex-col items-center justify-center space-y-3',
      fullScreen && 'min-h-screen'
    )}>
      {renderLoader()}
      {text && (
        <p className={clsx(
          'text-gray-600 font-medium animate-pulse',
          textSizeClasses[size]
        )}>
          {text}
        </p>
      )}
    </div>
  );

  if (fullScreen) {
    return (
      <div className="fixed inset-0 bg-white bg-opacity-80 backdrop-blur-sm z-50 flex items-center justify-center">
        {content}
      </div>
    );
  }

  return content;
};

export default Loading;
